import {CheckCircleOutlined, CloseCircleOutlined, LoadingOutlined} from '@ant-design/icons';
import {Typography} from 'antd';
import {IdVerificationStatus} from 'api/generated';
import React from 'react';

type Props = {
  status?: IdVerificationStatus | null;
};

const {Text} = Typography;

export const IdStatus: React.FC<Props> = ({status}) => {
  switch (status) {
    case IdVerificationStatus.RESUBMISSION_REQUESTED:
      return (
        <Text type="danger" strong>
          <CloseCircleOutlined /> <span>Resubmission requested</span>
        </Text>
      );
    case IdVerificationStatus.DECLINED:
      return (
        <Text type="danger" strong>
          <CloseCircleOutlined /> <span>Declined</span>
        </Text>
      );
    case IdVerificationStatus.SUBMITTED:
      return (
        <Text strong>
          <LoadingOutlined /> <span>Submitted</span>
        </Text>
      );
    case IdVerificationStatus.APPROVED:
      return (
        <Text type="success" strong>
          <CheckCircleOutlined /> <span>Verified</span>
        </Text>
      );
    case IdVerificationStatus.ABANDONED:
      return (
        <Text type="danger" strong>
          <CloseCircleOutlined /> <span>Abandoned</span>
        </Text>
      );
    case IdVerificationStatus.EXPIRED:
      return (
        <Text type="danger" strong>
          <CloseCircleOutlined /> <span>Expired</span>
        </Text>
      );
  }
  return (
    <Text type="danger" strong>
      <CloseCircleOutlined /> <span>Not verified</span>
    </Text>
  );
};
